import { toast } from 'sonner';

/** One place that sends transient feedback, so every screen reports results the same way. */
export const notify = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  info: (message: string, action?: { label: string; onClick: () => void }) =>
    toast(message, action ? { action: { label: action.label, onClick: action.onClick } } : {}),
};
